import React from 'react'
import styled from 'styled-components'
import Star from '../start'

const Container = styled.a` 
  width: 230px;
  border: 2px solid transparent;
  border-radius: 20px;
  margin-bottom: 22px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 0;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  box-shadow: 0px 3px 10px #dadada;
  @media (min-width: 464px){
    margin-left: 22px;
    width: 215px;
  }
  @media (min-width: 769px){
    width: 208px;
  }

  &:hover {
    border-color: #FDC910;
  }
  
  
`

const Header = styled.header`
 padding-top: 5px;
 padding-bottom: 5px;
 box-sizing: border-box;
 display: flex;
 justify-content: center;
 & > img {
   margin-bottom: 0;
 }
`
const Title = styled.h3`
  margin-top: 12px;
  margin-bottom: 10px;
  font-size: .8em;
  font-weight: 700;
  text-align: center;
  /* color: #373C44; */
`

const Description = styled.p`
  font-size: 0.8em;
  text-align: center;
  min-height: 78px;
  line-height: 21px;
  margin-bottom: 0;
`
const Footer = styled.footer`
  display: flex;
  width: 100%;
  justify-content: center;
`
const IntegrationItem = ({ title, description, logo, url}) => (
  <Container target="__blank" href={url} data-aos="fade-up" data-aos-duration="600">
    <Header>
      <img src={logo} alt="Marca" />
    </Header>
    <div>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </div>
    <Footer>
      <Star />
      <Star />
      <Star />
      <Star />
      <Star />
    </Footer>
  </Container>
)

export default IntegrationItem
